var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5416 2.09888C13.3115 1.61971 12.9507 1.21531 12.5008 0.932254C12.0509 0.649202 11.5301 0.499023 10.9986 0.499023C10.467 0.499023 9.9463 0.649202 9.49638 0.932254C9.04646 1.21531 8.68567 1.61971 8.45558 2.09888L0.339578 18.0639C-0.631422 19.9699 0.595578 22.5009 2.88158 22.5009H19.1146C21.4016 22.5009 22.6266 19.9709 21.6576 18.0639L13.5416 2.09888ZM10.9986 7.50088C11.2638 7.50088 11.5181 7.60624 11.7057 7.79377C11.8932 7.98131 11.9986 8.23566 11.9986 8.50088V13.5009C11.9986 13.7661 11.8932 14.0204 11.7057 14.208C11.5181 14.3955 11.2638 14.5009 10.9986 14.5009C10.7334 14.5009 10.479 14.3955 10.2915 14.208C10.1039 14.0204 9.99858 13.7661 9.99858 13.5009V8.50088C9.99858 8.23566 10.1039 7.98131 10.2915 7.79377C10.479 7.60624 10.7334 7.50088 10.9986 7.50088ZM10.9986 16.0009C11.2638 16.0009 11.5181 16.1062 11.7057 16.2938C11.8932 16.4813 11.9986 16.7357 11.9986 17.0009V17.5009C11.9986 17.7661 11.8932 18.0205 11.7057 18.208C11.5181 18.3955 11.2638 18.5009 10.9986 18.5009C10.7334 18.5009 10.479 18.3955 10.2915 18.208C10.1039 18.0205 9.99858 17.7661 9.99858 17.5009V17.0009C9.99858 16.7357 10.1039 16.4813 10.2915 16.2938C10.479 16.1062 10.7334 16.0009 10.9986 16.0009Z",
    fill: "#CA4949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.b076498152780d781c49f7f287f2c27a.svg";
export { ForwardRef as ReactComponent };